export default {
  en: {
    'ANNOTATE_CALL': 'Add Tag Annotation',
    'ADJUST_CALL_PAYMENT': 'Adjust Call Payments',
    'ADJUST_PAYMENT': 'Adjust Payments',
    'DISPUTE_CALL_CONVERSION': 'Dispute Call',
    'CALLER_ID': 'Caller ID',
    'DIALED_NUMBER': 'Dialed Number',
    'CALLS_SELECTED': '{numberOfCalls} call(s) selected',
    'CLEAR_CALLS_SELECTION': 'Clear Selection',
    'REVENUE': 'Revenue',
    'PAYOUT': 'Payout',
    'REMOVE_SELECTED_CALL': 'Remove from selected calls',
    'EDIT_SELECTED_CALLS': 'Edit selected call(s)',
    'TRANSCRIBE_SELECTED_CALLS' : 'Transcribe selected call(s)',
    'EDIT_CALLS_GENERAL' : 'Click up to {limitBulkRowCount} rows to select calls to edit',
    'EDIT_CALLS_PAYMENT': 'Edit all calls in the current report, or click row to select calls to edit',
    'TRANSCRIBE_CALLS': 'Transcribe all calls in the current report, or click row to select calls to transcribe',
    'EDIT_CALLS_COUNT_EXCEEDED': 'The number of calls in the report must be between 1 and {MAX_ADJUSTMENT_COUNT} to adjust',
    'EDIT_CALLS_BULK_ACTION_LIMIT': 'You cannot perform bulk action on more than {LIMIT_BULK_ACTION_COUNT} calls.',

    'CONFIRM_CHANGES': 'Confirm changes',
    'REVIEW_CHANGES': 'Review changes',
    
    'BID_AMOUNT': 'Bid Amount',
    'DURATION': 'Duration',
    'NAME': 'Name',
    'REASON': 'Reason',
    
    'RPC_CALCULATION_DETAILS': 'Calculation Details',
    'RPC_DUPLICATE_DETAILS': 'Duplicate Details',
    'RPC_ERROR_DETAILS': 'Error Details',

    'RING_TREE_EVENTS': 'Ring Tree Events',
    'RECORD': 'Record',
    'EVENTS': 'Events',
    'LOADING_CALL_DETAILS': 'Loading Call Details',
  }
};